import { DebitNoteRepository } from "../repositories/DebitNoteRepository";
import { DebitNoteOperationResult } from "../entities/DebitNoteEntity";

/**
 * Approve Debit Note Use Case
 * Approves a debit note
 */
export class ApproveDebitNoteUseCase {
  constructor(private repository: DebitNoteRepository) {}

  async execute(debitNoteId: number): Promise<DebitNoteOperationResult> {
    return await this.repository.approveDebitNote(debitNoteId);
  }
}
